
import React from 'react'
import developerpic from "../../images/DeveloperPic.png";
export default function Page1() {
  return (
    <div className='about-body'>
      
      <div className='h1-and-text'>
      <h1 className='about-h1'>ABOUT</h1>
      <span className='line' ></span>
       <p className='about-text'>
       Hello my name is Andrejs Grocs. 
       I am a Full Stack web developer based in Riga. 
       I am working with React, JavaScript, HTML5, SCSS, NoSQL, 
       MongoDB, SQL, and Apex Oracle technologies.
       </p>
    
      </div>
      <img className='developerpic' src={developerpic} alt='wind energy' />


    </div>
  )
}
